<template>
  <div>
    <portal to="modals">
      <BootstrapModal
        v-if="selectedProductActive && isMobile"
        class="modal modal-custom d-none d-md-block"
        :disableButton="true"
        @close="() => (selectedProductActive = false)"
      >
        <div class="row">
          <div class="col-12">
            <div
              class="card p-2 mb-0"
              style="height: 300px"
              v-if="selectedProduct"
            >
              <p class="text-order-normal m-2 font-weight-bold">
                Voorraadwaarde
              </p>

              <highcharts
                :options="chartOptions"
                style="height: 250px"
                v-for="product in filteredResult"
                :key="product.key"
                v-if="selectedProduct == product && showingChart"
              />

            </div>
          </div>
          <div class="col-12">
            <div class="card align-items-start p-3 mb-0" v-if="selectedProduct">
              <p class="text-order-normal mb-2 font-weight-bold">
                Verkoopadvies
              </p>
              <p style="font-size: 12px">
                Huidige voorraad: <b>{{ selectedProduct.currentStock }}</b>
              </p>
              <p style="font-size: 12px">
                Verwachte verkoop:
                <b
                  >Max. {{ selectedProduct.engine.baseSupplyNeeded }} producten
                  per week</b
                >
              </p>
              <p style="font-size: 12px">
                Advies voorrraad:
                <b
                  >Min.
                  {{
                    selectedProduct.engine.baseSupplyPlusAdditionalPercentage
                  }}
                  producten</b
                >
              </p>
              <p style="font-size: 12px">
                Nu te bestellen:
                <b>{{ selectedProduct.engine.toOrder }} producten</b>
              </p>
              <div class="row no-gutters" v-if="selectedProduct.images && selectedProduct.images.length">
                <div class="col-3" v-for="image in selectedProduct.images">
                  <img class="img-thumbnail" :src="image">
                </div>
              </div>
              <button
                class="btn btn-secondary btn-secondary-two mt-4"
                @click="isEditMobile = true"
              >
                Wijzigen
              </button>
              <hr />
              <div class="row" v-if="isEditMobile">
                <div class="col-12">
                  <form @submit.prevent="updateProductOrder">
                    <span class="mb-2 d-block font-weight-bold">
                      Verander besteladvies
                    </span>
                    <div class="form-group mb-1">
                      <span> Bestel: </span>
                      <input
                        type="number"
                        class="form-control"
                        v-model="
                          productOrderOverride[selectedProduct.id].amount
                        "
                      />
                    </div>
                    <div class="form-group mb-1">
                      <span> Reden: </span>
                      <input
                        type="text"
                        class="form-control"
                        v-model="
                          productOrderOverride[selectedProduct.id].reason
                        "
                      />
                    </div>
                    <button type="submit" class="btn border mt-2">
                      OPSLAAN
                    </button>
                    <small class="d-block mt-1">
                      OF DRUK OP ENTER, OM OP TE SLAAN.
                    </small>
                    <small
                      v-if="productSettingsSaved === selectedProduct.id"
                      style="color: green; display: block"
                      >Opgeslagen.</small
                    >
                  </form>
                </div>
                <div class="col-12">
                  <form @submit.prevent="updateProductSettings">
                    <span class="mb-2 d-block font-weight-bold">
                      Instellingen
                    </span>
                    <div class="form-group mb-1">
                      <span> Leverancier: </span>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.productSettings.supplier"
                      />
                    </div>
                    <div class="form-group mb-1">
                      <span class="d-block"> Stop met bijbestellen: </span>
                      <input
                        type="checkbox"
                        class="mt-1"
                        v-model="form.productSettings.stopped"
                      />
                    </div>
                    <button type="submit" class="btn border mt-2">
                      OPSLAAN
                    </button>
                    <small class="d-block mt-1">
                      OF DRUK OP ENTER, OM OP TE SLAAN.
                    </small>
                    <small
                      v-if="productSettingsSaved === selectedProduct.id"
                      style="color: green; display: block"
                      >Opgeslagen.</small
                    >
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BootstrapModal>
    </portal>

    <TableTemplate
      v-model="tableResult"
      :columns="tableColumns"
      :columnVariables="tableColumnVariables"
      :columnTooltip="defaultColumnTooltip"
      :columnInputActive="defaultColumnShowInput"
      :skeletonClass="skeletonClass"
      :selected="selected"
      :enable-sorting="true"
      :remove-checkboxes="true"
      :page="page"
      :max="max"
      :on-row-click="selectRow"
      @update-column-order="updateColumnOrder"
      @set-page="(v) => (page = v)"
      @set-filter="filterChange"
      sticky-container
      id="klantoverzicht"
      ref="table"
    >
      <template #above>
        <TableHeader
          :show-button="showButton"
          :alwaysShowMultiSelectCheckbox="true"
          :refetch="refetch"
          :export-params="exportEndpointParams"
          title="Order advies"
          export-endpoint="/drop/export/csv"
          csv-name="advice-orders"
          export-endpoint-type="post"
          @customize-layout="customizeLayout"
          @setting-layout="customizeSetting"
        >
          <template #header-buttons-after="props"> </template>
        </TableHeader>

        <div class="row bg-white my-lg-3 order-font-size-normal py-1">
          <div class="col-lg col-md-4 col-sm-12">
            <p class="text-center my-1 font-weight-bold text-order-normal">
              Totale Voorraadwaarde
            </p>
            <p class="text-center my-1 font-weight-bold order-font-size-normal">
              € {{ totalInventoryValue }}
            </p>
          </div>
          <div class="col-lg col-md-4 col-sm-12">
            <p class="text-center my-1 font-weight-bold text-order-normal">
              Gemiddelde Omlooptijd
            </p>
            <p class="text-center my-1 font-weight-bold order-font-size-normal">
              {{ averageTurnroundTime }} dagen
            </p>
          </div>
          <div class="col-lg col-md-4 col-sm-12">
            <p class="text-center my-1 font-weight-bold text-order-normal">
              Gemiddelde service level
            </p>
            <p class="text-center my-1 font-weight-bold order-font-size-normal">
              {{ averageServiceLevel }}%
            </p>
          </div>
          <div class="col-lg col-md-4 col-sm-12">
            <p class="text-center my-1 font-weight-bold text-order-normal">
              Totale verkoop afgelopen week
            </p>
            <p
              class="
                text-center
                my-1
                font-weight-bold
                text-order-success
                order-font-size-normal
              "
            >
              € {{ totalSalesLastWeek }}
            </p>
          </div>
          <div class="col-lg col-md-4 col-sm-12">
            <p class="text-center my-1 font-weight-bold text-order-normal">
              Gemiddelde verkoop per week
            </p>
            <p
              class="
                text-center
                my-1
                font-weight-bold
                text-order-failed
                order-font-size-normal
              "
            >
              € {{ averageSalesPerWeek }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-8">
            <div class="btn-group btn-group-responsive">
              <button
                type="button"
                class="btn btn-default btn-outline btn-default-outline"
                @click="setDate(new Date(Date.now() - 86400 * 1000 * 7))"
              >
                Week
              </button>
              <button
                type="button"
                class="btn btn-default btn-outline btn-default-outline"
                @click="setDate(new Date(Date.now() - 86400 * 1000 * 30))"
              >
                Maand
              </button>
              <button
                type="button"
                class="btn btn-default btn-outline btn-default-outline"
                @click="setDate(new Date(Date.now() - 86400 * 1000 * 365))"
              >
                Jaar
              </button>
              <button
                type="button"
                class="btn btn-default btn-outline btn-default-outline"
                @click="
                  setDate(
                    new Date(Date.now() - 86400 * 1000 * 14),
                    new Date(Date.now() - 86400 * 1000 * 7)
                  )
                "
              >
                Week-1
              </button>
              <button
                type="button"
                class="btn btn-default btn-outline btn-default-outline"
                @click="
                  setDate(
                    new Date(Date.now() - 86400 * 1000 * 60),
                    new Date(Date.now() - 86400 * 1000 * 30)
                  )
                "
              >
                Maand-1
              </button>
              <button
                type="button"
                class="btn btn-default btn-outline btn-default-outline"
                @click="
                  setDate(
                    new Date(Date.now() - 86400 * 1000 * 730),
                    new Date(Date.now() - 86400 * 1000 * 365)
                  )
                "
              >
                Jaar-1
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 d-flex justify-content-end">
            <TableDatePicker
              class="date-picker-shadow"
              :range="true"
              :initial_date.sync="dateFrom"
              :final_date.sync="dateTo"
            />
          </div>
        </div>

        <div class="row sticky" :class="{ 'bg-white': selectedProduct }" v-if="!isMobile" sticky-z-index="1000" sticky-offset="{top: 10}" v-sticky>
          <div class="col-12 col-md-8" style="max-width: 1440px !important">
            <div class="card p-2 mb-3" style="height: 280px" v-if="selectedProduct">
              <!-- <p class="text-order-normal m-2 font-weight-bold">
                Voorraadwaarde
              </p> -->
              <highcharts
                :options="chartOptions"
                style="height: 250px"
                v-for="product in filteredResult"
                :key="product.key"
                v-if="selectedProduct == product && showingChart"
              />
            </div>
          </div>
          <div class="col-12 col-md-4" style="position: relative">
            <div
              class="card align-items-start p-3"
              style="min-height: 280px"
              v-if="selectedProduct"
            >
              <div class="row">
                <div class="col">
                  <p class="text-order-normal mb-2 font-weight-bold">
                    Verkoopadvies
                  </p>
                  <span class="order-font-size-sm">
                    Huidige voorraad: <b>{{ selectedProduct.currentStock }}</b>
                  </span>
                  <span class="order-font-size-sm">
                    Verwachte verkoop:
                      <b>{{ selectedProduct.engine.baseSupplyNeeded }} </b>
                    <i class="fa fa-info-circle icon-custom" data-toggle="tooltip" data-placement="top" :title="'Max. ' + selectedProduct.engine.baseSupplyNeeded + ' producten per week'"></i>
                  </span>
                  <br>
                  <span class="order-font-size-sm">
                    Advies voorrraad:
                    <b
                    >{{ selectedProduct.engine.baseSupplyPlusAdditionalPercentage }}</b>
                    <i class="fa fa-info-circle icon-custom" data-toggle="tooltip" data-placement="top" :title="'Min. ' + selectedProduct.engine.baseSupplyPlusAdditionalPercentage + ' producten'"></i>
                  </span>
                  <br>
                  <span class="order-font-size-sm">
                    Nu te bestellen:
                    <b>{{ selectedProduct.engine.toOrder }}</b>
                    <i class="fa fa-info-circle icon-custom" data-toggle="tooltip" data-placement="top" :title="selectedProduct.engine.toOrder + ' producten'"></i>
                  </span>
                  <br>
                  <button
                    class="btn btn-secondary mt-2"
                    @click="isEdit = !isEdit"
                  >
                    {{ isEdit? 'Annuleren' : 'Wijzigen' }}
                  </button>
                </div>
                <div class="col">
                  <div id="carouselWithImageIndicators" class="carousel slide" data-ride="carousel">
                    <ol class="carousel-indicators">
                      <li data-target="#carouselWithImageIndicators" v-for="(image, index) in selectedProduct.thumbnails" :data-slide-to="index" class="border border-secondary" :class=" index === 0? 'active' : '' ">
                        <img class="d-block w-100" :src="image" alt="" />
                      </li>

                    </ol>
                    <div class="carousel-inner">
                      <div v-for="(image, index) in selectedProduct.thumbnails" :key="index" class="border carousel-item" :class="index === 0 ? 'active' : ''" >
                        <img class="d-block img-thumbnail" :src="image" alt="" />
                      </div>
                    </div>
                    <a class="carousel-control-prev" href="#carouselWithImageIndicators" role="button" data-slide="prev">
                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselWithImageIndicators" role="button" data-slide="next">
                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                      <span class="sr-only">Next</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="row" v-if="isEdit">
                <div class="col">
                  <form @submit.prevent="updateProductOrder">
                    <span class="my-3 d-block font-weight-bold">
                      Verander besteladvies
                    </span>
                    <div class="form-group mb-2">
                      <span> Bestel: </span>
                      <input
                        type="number"
                        class="form-control"
                        v-model="
                          productOrderOverride[selectedProduct.id].amount
                        "
                      />
                    </div>
                    <div class="form-group mb-2">
                      <span> Reden: </span>
                      <input
                        type="text"
                        class="form-control"
                        v-model="
                          productOrderOverride[selectedProduct.id].reason
                        "
                      />
                    </div>
                    <button type="submit" class="btn border mt-3">
                      OPSLAAN
                    </button>
                    <small class="d-block mt-1">
                      OF DRUK OP ENTER, OM OP TE SLAAN.
                    </small>
                    <small
                      v-if="productSettingsSaved === selectedProduct.id"
                      style="color: green; display: block"
                      >Opgeslagen.</small
                    >
                  </form>
                </div>
                <div class="col">
                  <form @submit.prevent="updateProductSettings">
                    <span class="my-3 d-block font-weight-bold">
                      Instellingen
                    </span>
                    <div class="form-group mb-2">
                      <span> Leverancier: </span>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.productSettings.supplier"
                      />
                    </div>
                    <div class="form-group mb-2">
                      <span class="d-block"> Stop met bijbestellen: </span>
                      <input
                        type="checkbox"
                        class="mt-2"
                        v-model="form.productSettings.stopped"
                      />
                    </div>
                    <button type="submit" class="btn border mt-3">
                      OPSLAAN
                    </button>
                    <small class="d-block mt-1">
                      OF DRUK OP ENTER, OM OP TE SLAAN.
                    </small>
                    <small
                      v-if="productSettingsSaved === selectedProduct.id"
                      style="color: green; display: block"
                      >Opgeslagen.</small
                    >
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-0">
          <div class="col-sm-12 col-md-9 d-flex">
            <div class="mr-3">
              <h4 class="mb-1" style="line-height:normal;">
                Producten (<span class="font-weight-bold">{{ filteredResult.length }}</span> / <span>{{result.length}}</span>)
              </h4>
              <p> Overzicht van de producten + verkopen </p>
            </div>
            <TableMainSearchFieldTag placeholder="Search" :value="searchQuery" @input="searchQueryDebounce" />
            <FormSearchSelector
              v-model="site"
              class="ml-2 website-search"
              id="website"
              placeholder="Zoek website..."
              endpoint="/api/websites"
              titleField="domainname"
              searchParameter="name"
              @select-item="setWebsiteParam"

              :infinite-scrolling="true"
              :table="true"

              v-slot="item"
            >
              <div class="p-1 item">
                {{ item.domainname }}
              </div>
            </FormSearchSelector>
            <RefreshBtn
              :loading="isLoadingTableResult"
              @click.native="refreshAdviceOrder"
            />
          </div>
          <div class="col-sm-12 col-md-3" v-if="availablePageSizeValues.length">
            <MultiplePageSizesSelection
              class="float-right"
              v-model="page_size"
              :available-values="availablePageSizeValues"
            />
          </div>
        </div>

        <div class="mt-3 mb-1">
          <span class="mr-2"> Legenda </span>
          <span class="tag mb-1 d-inline-block" :style="tagColors['brand']">
            Productmerk
          </span>
          <span class="tag mb-1 d-inline-block" :style="tagColors['category']">
            Productcategorie
          </span>
          <span class="tag mb-1 d-inline-block" :style="tagColors['added']">
            Toegevoegd sinds
          </span>
          <span class="tag mb-1 d-inline-block" :style="tagColors['supplier']">
            Leverancier
          </span>
        </div>
      </template>

      <template #cell-name="{ value, item }">
        <div class="my-1">
          <span>
            {{ value }}
          </span>
          <div class="d-flex mt-1">
            <span v-if="item.brand" class="tag" :style="tagColors['brand']">
              {{ item.brand }}
            </span>
            <span
              v-if="item.category"
              class="tag"
              :style="tagColors['category']"
            >
              {{ item.category }}
            </span>
            <span
              v-if="item.date_added"
              class="tag"
              :style="tagColors['added']"
            >
              {{ item.date_added | moment("from") }}
            </span>
            <span
              v-if="item.supplier"
              class="tag"
              :style="tagColors['supplier']"
            >
              {{ item.supplier }}
            </span>
          </div>
        </div>
      </template>

      <template #cell-thumbnails="{ value }">
        <img v-if="value" :src="value" class="my-3" style="width: 100px" />
      </template>

      <template #cell-engine="{ value }">
        <span class="d-flex align-items-center">
          <span
            class="dot mr-2"
            :style="{ backgroundColor: value && value.color }"
          ></span>
          {{ value.value }}
        </span>
      </template>

      <template #cell-stock_value="{ value }">
        <span class="d-flex"> € {{ value }} </span>
      </template>

      <template #cell-revenue_1y="{ value }">
        <span class="d-flex"> € {{ value }} </span>
      </template>
      <template #cell-revenue_custom="{ value }">
        <span class="d-flex"> € {{ value }} </span>
      </template>

      <template #cell-cycle_time="{ value }">
        <span class="d-flex" v-if="value"> {{ value }} dagen </span>
      </template>

      <template #cell-service_level="{ value }">
        <span class="d-flex"> {{ value }}% </span>
      </template>

      <template #cell-orders_7d="{ item }">
        <span class="my-1">
          {{ item.orders_7d }}
          <div>
            {{ item.unique_orders_7d }}
          </div>
        </span>
      </template>

      <template #cell-orders_1m="{ item }">
        <span class="my-1">
          {{ item.orders_1m }}
          <div>
            {{ item.unique_orders_1m }}
          </div>
        </span>
      </template>

      <template #cell-orders_1y="{ item }">
        <span class="my-1">
          {{ item.orders_1y }}
          <div>
            {{ item.unique_orders_1y }}
          </div>
        </span>
      </template>

      <template #cell-pct_1y="{ value }">
        <span> € {{ value }} </span>
      </template>

      <template #empty-state>
        <EmptyStatePlaceholder title="Er zijn geen adviesbestellingen">
          <svg
            width="18"
            height="18"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <path
                  d="M4.5,12.5l-4,1,1-3v-9a1,1,0,0,1,1-1h10a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1Z"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <line
                  x1="7.5"
                  y1="3"
                  x2="7.5"
                  y2="6"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
                <circle
                  cx="7.5"
                  cy="9"
                  r="0.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></circle>
              </g>
            </g>
          </svg>
        </EmptyStatePlaceholder>
      </template>
    </TableTemplate>
  </div>
</template>

<script>

import TableTemplate from "src/layout/Table/TableTemplate";
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue";
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue";
import TableMainSearchField from "../layout/TableMainSearchField";
import TableMainSearchFieldTag from "../layout/TableMainSearchFieldTag";
import TableDatePicker from "../components/Inputs/TableDatePickerField";
import RefreshBtn from "../layout/RefreshBtn";
import MultiplePageSizesSelection from "../layout/Table/MultiplePageSizesSelection";
import BootstrapModal from "../layout/Modals/BootstrapModal";
import FormSearchSelector from '../components/Inputs/FormSearchSelector.vue'
import TableCell from "../components/Table/TableCell";

import table from "src/mixins/table";
import tableFieldOptions from "src/mixins/tableFieldOptions";
import selectMultipleItems from "src/mixins/selectMultipleItems";
import { filters } from "src/utils/advice-order-filters";
import { debounce } from "lodash";
import { chunk } from "lodash"

import mom from "moment";

const BRANDS_TITLE = "Product Merk Filter";
const SUPPLIERS_TITLE = "Leverancier Filter";

export default {
  metaInfo: {
    title: "Order advies",
  },
  components: {
    FormSearchSelector,
    TableHeader,
    TableMainSearchField,
    TableTemplate,
    TableDatePicker,
    TableCell,
    RefreshBtn,
    EmptyStatePlaceholder,
    MultiplePageSizesSelection,
    BootstrapModal,
    TableMainSearchFieldTag,
  },
  mixins: [
    selectMultipleItems,
    tableFieldOptions,
    table({
      pageReference: "advice-orders",

      manualPagination: true,
      disableAlphabeticalSort: true,
      disablePageChangeRefetch: true,

      columnTranslationMaps: {
        Afbeeldingen: "thumbnails",
        SKU: "reference",
        Naam: "name",
        Voorraad: "currentStock",
        "Groothandel voorraad": "wholesale_stock",
        week: "orders_7d",
        maand: "orders_1m",
        jaar: "orders_1y",
        "Omzet jaar": "revenue_1y",
        Voorraadwaarde: "stock_value",
        "Service Level": "service_level",
        "Engine advies": "engine",
        Omlooptijd: "cycle_time",
        Invoer: "orders_custom",
        "Omzet invoer": "revenue_custom",
      },
      selectCustomization: (vm, filters) => (vm.filters = filters),

      defaultColumns: [
        "SKU",
        "Naam",
        "Voorraad",
        "Groothandel voorraad",
        "week",
        "maand",
        "jaar",
        "Omzet jaar",
        "Engine advies",
      ],
      defaultColumnSizes: {
        reference: 70,
        name: 360,
        currentStock: 130,
        wholesale_stock: 130,
        orders_7d: 130,
        orders_1m: 130,
        orders_1y: 130,
        revenue_1y: 130,
      },
      defaultColumnShowInput: {
        SKU: false,
        Naam: false,
        Voorraad: false,
        "Groothandel voorraad": false,
        week: true,
        maand: true,
        jaar: true,
        "Omzet jaar": true,
        Voorraadwaarde: false,
        "Service Level": false,
        "Engine advies": false,
        Omlooptijd: false,
        Invoer: false,
        "Omzet invoer": false,
      },
      defaultColumnTooltip: {
        SKU: "SKU - Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        Naam: "Naam - Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        Voorraad:
          "Voorraad - Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        "1W": "1W - Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        "1M": "1M - Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        "1Y": "1Y - Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        "Omzet 1Y":
          "Omzet 1Y - Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        Voorraadwaarde:
          "Voorraadwaarde- Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        "Service Level":
          "Service Level - Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        "Engine advies":
          "Engine advies - Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        Omlooptijd:
          "Omlooptijd - Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        Invoer:
          "Invoer - Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        "Omzet invoer":
          "Omzet invoer - Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      },
      columnConfigurationId: "advice-order",

      params: {
        search: "",
        site: "",
      },
      page_size: 100,
      toISOFields: ["initialDate", "finalDate"],


      route: "/drop/products",
      routeTriggers: ['site'],
    }),
  ],
  data() {
    return {
      mappedProducts: new Map(),

      searchQuery: [],
      productSettings: {},

      productOrderOverride: {},
      productSettingsSaved: false,
      productOrderOverrideSaved: false,
      filters: [],

      settings: {},
      form: {
        productSettings: {},
      },
      customLoading: false,
      selectedProduct: null,
      showingChart: true,

      dateFrom: null,
      dateTo: null,
      dateRange: [],

      selectedProductActive: false,
      isEdit: false,
      isEditMobile: false,
      filter: {
        pct_1m: {
          value: 1,
        },
        pct_1y: {
          value: 1,
        },
        pct_7d: {
          value: 1,
        },
        orders_1y: {
          value: 1,
        },
      },
    };
  },
  created() {
    this.loadSettings();
    const filters = localStorage.getItem("advice-order-filters");
    if (filters) this.filters = JSON.parse(filters);

    const brands = Array.from(this.availableBrands);
    const suppliers = Array.from(this.availableSuppliers);

    const brandsFilters = this.filters
      .filter((filter) => filter.title === BRANDS_TITLE)
      .map((filter) => filter.value);
    const suppliersFilters = this.filters
      .filter((filter) => filter.title === SUPPLIERS_TITLE)
      .map((filter) => filter.value);

    brandsFilters.forEach((filter) => {
      if (!brands.includes(filter.value)) {
        this.filters.splice(
          this.filters.findIndex((item) => filter.value === item.value),
          1
        );
      }
    });
    suppliersFilters.forEach((filter) => {
      if (!suppliers.includes(filter.value)) {
        this.filters.splice(
          this.filters.findIndex((item) => filter.value === item.value),
          1
        );
      }
    });
  },
  methods: {
    setWebsiteParam(item) {
      if(!item) return;
      const { domainname } = item
      this.site = domainname
      return domainname
    },
    async loadProductsSku(products) {
      const skus = products.reduce((list, { reference }) => ([...list, `sku[]=${reference}`]), [])
      const mappedProducts = await Promise.all(
        chunk(skus, 350).map(async skuGroup => {
          const { data } = await this.axios.get(`/api/products?${skuGroup.join("&")}`)
          return data.results
        })
      )

      const map = new Map()
      mappedProducts.flat().forEach(product => map.set(product.sku, product))
      return map
    },
    getPriceIncludingTax(product, tax) {
      switch (tax.toUpperCase()) {
        case "HOOG": {
          return product.price * 1.21
        }
        case "LAAG": {
          return product.price * 1.09
        }
      }
    },
    filterChange(event) {
      const column = event.target;
      if (column === "week") {
        this.filter.pct_7d.value = parseInt(event.value);
      }
      if (column === "maand") {
        this.filter.pct_1m.value = parseInt(event.value);
      }
      if (column === "jaar") {
        this.filter.pct_1y.value = parseInt(event.value);
      }
      if (column === "Omzet jaar") {
        this.filter.orders_1y.value = parseInt(event.value);
      }
    },
    searchQueryDebounce: debounce(function (payload) {
      this.searchQuery = payload;
    }, 300),

    getSelectedExtraSections() {
      return this.filters;
    },

    async updateProductOrder() {
      this.$handlePromise(async () => {
        await this.axios.post(
          "/drop/products/order",
          this.productOrderOverride[this.selectedProduct.id]
        );
        this.$store.dispatch('clearCacheSearch', "drop/products")
        this.productOrderOverrideSaved = this.selectedProduct.id;

        this.loadSettings(true, false);
        this.clearFetchCache();
      });
    },
    async updateProductSettings() {
      this.$handlePromise(async () => {
        this.productSettings[this.selectedProduct.id] =
          this.form.productSettings;
        await this.axios.post(
          "/drop/products/settings",
          this.productSettings[this.selectedProduct.id]
        );
        this.$store.dispatch('clearCacheSearch', "drop/products")
        this.productSettingsSaved = this.selectedProduct.id;

        this.loadSettings(true, false);
        this.clearFetchCache();
      });
    },

    selectRow(item) {
      this.selectedProduct = item;
      this.selectedProductActive = true;

      this.form.productSettings = Object.assign(
        {},
        this.productSettings[this.selectedProduct.id]
      );

      this.toggleChart()
    },
    toggleChart() {
      this.showingChart = false
      this.$nextTick(() => this.showingChart = true)
    },
    async loadSettings(fresh, showLoading = true) {
      if (showLoading) this.customLoading = true;

      const [
        { data: productSettings },
        { data: graphSettings },
        { data: ordersData },
      ] = await Promise.all([
        this.$store.dispatch("cachedGet", {
          endpoint: "/drop/products/settings",
          fresh,
        }),
        this.$store.dispatch("cachedGet", {
          endpoint: "/drop/settings",
          fresh,
        }),
        this.$store.dispatch("cachedGet", {
          endpoint: "/drop/products/order",
          fresh,
        }),
      ]);

      if (!showLoading) return;

      this.settings = graphSettings.reduce(
        (obj, curr) => ({
          ...obj,
          [curr.topic]: curr,
        }),
        {}
      );
      this.productSettings = productSettings.reduce(
        (obj, curr) => ({
          ...obj,
          [curr.product_id]: curr,
        }),
        {}
      );
      this.productOrderOverride = ordersData.reduce(
        (obj, curr) => ({
          ...obj,
          [curr.product_id]: curr,
        }),
        {}
      );

      this.customLoading = false;
    },
    refreshAdviceOrder() {
      this.loadSettings(true);
      this.get(undefined, true);
    },
    showCustomerInformation(item) {
      this.$pushModal({
        modal: "CustomerInformation",
        toBind: {
          item,
        },
      });
    },

    settingsToPlotBands() {
      let plotBands = [];
      let settingsToTake = [
        "y2019_ramadan",
        "y2019_eid_fitr",
        "y2019_eid_adha",
        "y2019_december",
        "y2019_other",
        "y2020_ramadan",
        "y2020_eid_fitr",
        "y2020_eid_adha",
        "y2020_december",
        "y2020_other",
        "y2021_ramadan",
        "y2021_eid_fitr",
        "y2021_eid_adha",
        "y2021_december",
        "y2021_other",
        "y2022_ramadan",
        "y2022_eid_fitr",
        "y2022_eid_adha",
        "y2022_december",
        "y2022_other",
      ];

      const settings = this.settings;
      for (const settingToTake of settingsToTake) {
        if (!settings[settingToTake].value) {
          continue;
        }
        let year = settingToTake.split("y")[1].split("_")[0];
        let weekStart =
          -0.5 + parseInt(settings[settingToTake].value.trim()) + "";
        let weekEnd = 0.5 + parseInt(settings[settingToTake].value.trim()) + "";

        if (settings[settingToTake].value.indexOf(",") !== -1) {
          weekStart = settings[settingToTake].value.split(",")[0].trim();
          weekEnd = settings[settingToTake].value
            .split(",")
            .slice(-1)[0]
            .trim();
        }

        plotBands.push({
          color: "#FED8B1", // Color value
          from: mom(year + " " + weekStart, "YYYY w")
            .toDate()
            .getTime(), // Start of the plot band
          to: mom(year + " " + weekEnd, "YYYY w")
            .toDate()
            .getTime(), // End of the plot band
        });
      }

      return plotBands;
    },

    calculateCustomDateRangeFields(dateFrom, dateTo) {
      let dateFromYearWeek = mom(new Date(dateFrom)).format("YYYY w");
      let dateToYearWeek = mom(new Date(dateTo)).format("YYYY w");

      if (new Date(dateTo) > new Date(dateFrom)) {
        for (const product of this.filteredResult) {
          const orderIndex = Object.keys(product.orders);
          let start = orderIndex.indexOf(dateFromYearWeek);
          let end = orderIndex.indexOf(dateToYearWeek);

          product.orders_custom = 0;
          for (let i = start; i <= end; i++) {
            product.orders_custom += product.orders[orderIndex[i]] || 0;
          }
          product.revenue_custom = (
            product.orders_custom * product.price
          ).toFixed(2);
        }
      }
    },
    setDate(from, to) {
      this.dateFrom = mom(from).format("YYYY-MM-DD");
      if (!to) {
        this.dateTo = mom(new Date()).format("YYYY-MM-DD");
      } else {
        this.dateTo = mom(to).format("YYYY-MM-DD");
      }
    },
    fixedNumber(number) {
      return isNaN(number) ? "---" : number.toFixed(2);
    },
    parseNumber(number) {
      if (!number) return "N/A";
      const parsed = parseFloat((number + "").replace(",", ".")).toFixed(0);
      return isNaN(parsed) ? "N/A" : `${parsed}%`;
    },
    filterDateValuesByDate(values, dateFrom, dateTo) {
      if (!dateFrom && !dateTo) return values

      const dateFromYearWeek = dateFrom && mom(new Date(dateFrom));
      const dateToYearWeek = dateTo && mom(new Date(dateTo));

      const newValues = {}
      Object.keys(values).filter((date) => {
        const dateMom = mom(date, "YYYY w")
        if (
          dateFromYearWeek && dateToYearWeek && !dateMom.isBetween(dateFromYearWeek, dateToYearWeek) ||
          dateFromYearWeek && dateMom.isBefore(dateFromYearWeek)
        ) return;

        newValues[date] = values[date]
      })

      return newValues
    },
  },
  computed: {
    computedProductOrders() {
      return this.filterDateValuesByDate(this.selectedProduct.orders, this.dateFrom, this.dateTo)
    },
    computedStockCount() {
      return this.filterDateValuesByDate(this.selectedProduct.stockCount, this.dateFrom, this.dateTo)
    },
    isMobile() {
      return (
        Math.min(window.screen.width, window.screen.height) < 768 ||
        navigator.userAgent.indexOf("Mobi") > -1
      );
    },
    availableBrands() {
      return new Set(
        this.computedResult.map((prod) => prod.brand).filter((brand) => brand)
      );
    },
    availableSuppliers() {
      return new Set(
        this.computedResult
          .map((prod) => prod.supplier)
          .filter((supplier) => supplier)
      );
    },
    availablePageSizeValues() {
      if (this.filteredResult.length > 10) {
        return [100, this.filteredResult.length];
      }
      return [10];
    },
    expandCustomizations() {
      return [
        {
          title: "Filters",
          values: Object.keys(filters),
        },
        {
          title: BRANDS_TITLE,
          values: this.availableBrands,
        },
        {
          title: SUPPLIERS_TITLE,
          values: this.availableSuppliers,
        },
      ];
    },
    exportEndpointParams() {
      return {
        site: this.site,
        products: this.filteredResult.map((item) => item.reference),
      };
    },
    computedResult() {
      const settings = this.productSettings;

      if (!this.result) {
        return [];
      }

      return this.result.map
        ? this.result.map((item) => ({
            ...item,
            supplier: settings[item.id] ? settings[item.id].supplier : null,

            pct_1m_parsed: this.parseNumber(item.pct_1m * this.filter.pct_1m.value),
            pct_7d_parsed: this.parseNumber(item.pct_7d * this.filter.pct_7d.value),
            pct_1y_parsed: this.parseNumber(item.pct_1y * this.filter.pct_1y.value),
            revenue_1y: (
              this.filter.orders_1y.value *
              item.orders_1y *
              item.price
            ).toFixed(2),
            stock_value: (item.currentStock * item.price).toFixed(2),
            service_level: Math.round(
              (Object.values(item.stockCount).filter(
                (v) => v > item.engine.baseSupplyNeeded
              ).length /
                Object.keys(item.stockCount).length) *
                100
            ),
            cycle_time: Math.round(
              (item.currentStock / ((item.currentStock * item.price) / 2)) * 365
            ),
          }))
        : [];
    },
    computedResultFilteredBySearch() {
      let currentStep = this.searchQuery.length;
      let preFiltered = localStorage.getItem(`searchResult-${currentStep - 1}`);
      let filtered = preFiltered ? JSON.parse(preFiltered) : this.computedResult;

      if (this.searchQuery.length) {
        let excluded = [];
        let included = [];

        this.searchQuery.forEach((word) => {
          if (word[0] === "-") {
            excluded.push(word.slice(1).toLowerCase());
          } else {
            included.push(word.toLowerCase());
          }
        });

        const searchResult = [];

        excluded = excluded.slice(-1);
        included = included.slice(-1);

        for (var i = 0; i < filtered.length; i++) {
          if (included.length) {
            for (var ii = 0; ii < included.length; ii++) {
              if (excluded.length) {
                for (var iii = 0; iii < excluded.length; iii++) {
                  let isFiltered =
                    filtered[i].name.toLowerCase().includes(included[ii]) ||
                    filtered[i].reference.toLowerCase().includes(included[ii]) ||
                    (filtered[i].ean13 && filtered[i].ean13.includes(included[ii]))
                  let isExcluded =
                    !filtered[i].name.toLowerCase().includes(excluded[iii]) &&
                    !filtered[i].reference.toLowerCase().includes(excluded[iii]) &&
                    (!filtered[i].ean13 && !filtered[i].ean13.includes(excluded[iii]))
                  if (isFiltered && isExcluded) {
                    searchResult.push(filtered[i])
                  }
                }
              } else {
                if (included.length > 1) {
                  let isIncludedExact =
                    filtered[i].name.toLowerCase().includes(included[ii]) && filtered[i].name.toLowerCase().includes(included[ii + 1]) ||
                    filtered[i].reference.toLowerCase().includes(included[ii]) && filtered[i].reference.toLowerCase().includes(included[ii + 1]) ||
                    (filtered[i].ean13 && (filtered[i].ean13.includes(included[ii]) && filtered[i].ean13.includes(included[ii + 1])))
                  if (isIncludedExact) {
                    searchResult.push(filtered[i])
                  }
                } else {
                  let isIncluded =
                    filtered[i].name.toLowerCase().includes(included[ii]) ||
                    filtered[i].reference.toLowerCase().includes(included[ii]) ||
                    (filtered[i].ean13 && filtered[i].ean13.includes(included[ii]))
                  if (isIncluded) {
                    searchResult.push(filtered[i])
                  }
                }
              }
            }
          }
        }

        localStorage.setItem(`searchResult-${currentStep}`, JSON.stringify(searchResult));

        return searchResult;
      }

      return filtered;
    },
    filteredItems() {
      let filtered = this.computedResultFilteredBySearch;

      if (this.filters.length) {
        // Do not delete these references! They are used for giving a hint to VueJs reactivity system. If you remove them, then this computed property won't be reactive anymore.
        this.productOrderOverride;
        // --------

        const mainFilters = this.filters.filter((filter) => filter.title === "Filters") || [];

        filtered = mainFilters.reduce((filtered, filter) => {
          return filtered.filter((prod) => {
            return filters[filter.value](prod, this);
          });
        }, filtered);

        const brands = this.filters.filter((filter) => filter.title === BRANDS_TITLE).map((filter) => filter.value);
        const suppliers = this.filters.filter((filter) => filter.title === SUPPLIERS_TITLE).map((filter) => filter.value);

        if (brands.length) {
          filtered = filtered.filter((prod) => brands.includes(prod.brand));
        }

        if (suppliers.length) {
          filtered = filtered.filter((prod) =>
            suppliers.includes(prod.supplier)
          );
        }

        return filtered;
      }
      return filtered;
    },

    totalInventoryValue() {
      const filteredResult = this.filteredResult
      if (!filteredResult) return;

      return this.fixedNumber(filteredResult.reduce((a, b) => a + b.currentStock * b.price, 0))
    },
    averageTurnroundTime() {
      const filteredResult = this.filteredResult
      if (!filteredResult) return;

      return this.fixedNumber(
        filteredResult.reduce((a, b) => a + (b.cycle_time || 0), 0) /
        filteredResult.filter((f) => f.cycle_time).length
      );
    },
    averageServiceLevel() {
      const filteredResult = this.filteredResult
      if (!filteredResult) return;

      return this.fixedNumber(
        filteredResult.reduce((a, b) => a + (b.service_level || 0), 0) /
        filteredResult.filter((f) => f.service_level).length
      );
    },
    totalSalesLastWeek() {
      const filteredResult = this.filteredResult
      if (!filteredResult) return;

      return this.fixedNumber(
        filteredResult.reduce((a, b) => a + b.orders_7d * b.price, 0)
      );
    },
    averageSalesPerWeek() {
      const filteredResult = this.filteredResult
      if (!filteredResult) return;

      return this.fixedNumber(
        filteredResult.reduce((a, b) => a + b.orders_1y * b.price, 0) / 52
      );
    },
    /// This is used on table.js
    filteredResult() {
      const filtered = this.filteredItems.slice();
      const property = this.sort;
      const order = this.order;

      for (var i = 0; i < filtered.length; i++) {
        if (this.productSettings[filtered[i].id] && this.productSettings[filtered[i].id].stopped) {
          filtered[i].isDanger = true
        }
      }

      property &&
        filtered.sort((a, b) => {
          switch (property) {
            case "name": {
              return order === "asc"
                ? a[property].localeCompare(b[property])
                : b[property].localeCompare(a[property]);
            }
            case "engine": {
              return this.sortNumber(
                a.engine.value,
                b.engine.value,
                true,
                order
              );
            }

            default: {
              return this.sortNumber(a[property], b[property], false, order);
            }
          }
        });

      const mappedProducts = this.mappedProducts
      return filtered
        ? filtered.map(product => {
          const mappedProduct = mappedProducts.get(product.reference)

          return {
            ...product,
            price: !mappedProduct ? product.price :  this.getPriceIncludingTax(product, mappedProduct.tax),
          }
        })
        : [];
    },
    // --------
    loadedSettingsAndProducts() {
      return !this.loadingSettings && !this.isLoadingTableResult;
    },
    tagColors() {
      return {
        brand: { backgroundColor: "#6c757d" },
        category: { backgroundColor: "#0081C9" },
        added: { backgroundColor: "#F48F32" },
        supplier: { backgroundColor: "#397678" },
      };
    },
    pointStart() {
      const orders = this.computedProductOrders
      const keys = Object.keys(orders)

      let smallest = mom(keys[0], 'YYYY w')
      for (const key of keys) {
        const possiblySmaller = mom(key, 'YYYY W')
        if (possiblySmaller.isBefore(smallest)) {
          smallest = possiblySmaller
        }
      }

      console.log(smallest.format("YYYY w"))
      return smallest.toDate().getTime()
    },
    chartOptions() {
      var self = this;

      console.log(self.selectedProduct, this.pointStart)

      if (self.selectedProduct) {
        const orders = this.computedProductOrders
        let from = this.dateFrom ? new Date(this.dateFrom).getTime() : new Date(this.selectedProduct.date_added).getTime()
        let to = this.dateTo ? new Date(this.dateTo).getTime(): new Date().getTime()

        let interval = (to - from) / Object.keys(orders).length

        return {
          title: {
            text: self.selectedProduct.name,
          },
          credits: {
            enabled: false
          },
          chart: {
            type: "spline",
            zoomType: "x",
            backgroundColor: "rgba(0,0,0,0)"
          },
          xAxis: {
            type: "datetime",
            labels: {
              enabled: true,
              format: "{value:%d-%m}",
              rotation: 0,
              align: "left",
            },
            plotBands: this.settingsToPlotBands(),
            min: this.dateFrom
              ? new Date(this.dateFrom).getTime()
              : new Date(self.selectedProduct.date_added).getTime(),
            max: this.dateTo
              ? new Date(this.dateTo).getTime()
              : null,
          },
          yAxis: {
            title: {
              text: "",
            },
            min: 0,
          },
          plotOptions: {
            spline: {
              lineWidth: 4,
              states: {
                hover: {
                  lineWidth: 5,
                },
              },
              cropThreshold: 1000,
              pointInterval: interval,
              pointStart: this.dateFrom
                ? new Date(this.dateFrom).getTime()
                : new Date(self.selectedProduct.date_added).getTime(),
            },
          },
          series: [
            {
              name: "verkocht",
              // for each order (per week),
              data: Object.entries(orders).map((h) => {
                return [h[0], h[1]];
              }),
              color: "#16D379",
            },
            {
              name: "voorraad",
              // for each order (per week),
              data: Object.entries(this.computedStockCount).map((h) => {
                return [h[0], h[1]];
              }),
              color: "#C7314A",
            },
          ]
        };
      }
    },
  },
  watch: {
    filters(filters) {
      localStorage.setItem("advice-order-filters", JSON.stringify(filters));
    },
    selectedProduct({ id }, oldProduct) {
      if (id) {
        document
          .querySelector(`#table-row-${id}`)
          .classList.add("selected-row");
      }
      if (oldProduct && oldProduct.id) {
        const oldRow = document.querySelector(`#table-row-${oldProduct.id}`);
        if (oldRow) oldRow.classList.remove("selected-row");
      }
    },
    tableResult(val) {
      this.$emit("table-items", val);
      this.toggleChart()
    },
    loadedSettingsAndProducts(val) {
      if (val) {
        this.result.forEach(({ id }) => {
          if (!this.settings[id]) {
            this.settings[id] = { product_id: id };
            this.productOrderOverride[id] = { product_id: id };
          }
        });
      }
    },
    dateFrom(newDate, oldDate) {
      this.toggleChart()
      if (!newDate) {
        return;
      }
      if (newDate !== oldDate) {
        this.calculateCustomDateRangeFields(newDate, this.dateTo);
      }
    },
    dateTo(newDate, oldDate) {
      this.toggleChart()
      if (!newDate) {
        return;
      }
      if (newDate !== oldDate) {
        this.calculateCustomDateRangeFields(this.dateFrom, newDate);
      }
    },
    async result(products) {
      this.mappedProducts = await this.loadProductsSku(products)
    },
  },
};
</script>

<style>
.selected-row {
  border-top: 1px solid var(--mint-green) !important;
}
.selected-row + tr {
  border-top: 1px solid var(--mint-green) !important;
}
.selected-row td {
  background-color: rgba(50, 202, 210, 0.1);
}
.table-danger {
  border-top: 1px solid #ed969e !important;
}
.table-danger + tr {
  border-top: 1px solid #ed969e !important;
}
.table-danger td {
  background-color: #f5c6cb !important;
}
.table-danger:hover td {
  background-color: #ed9ba4 !important;
}
</style>

<style scoped>
#klantoverzicht::v-deep .content-wrapper > .content-wrapper {
  flex-direction: column-reverse;
}
.graph-wrapper {
  width: 100% !important;
  min-width: unset;
  max-width: unset;
}

.empty-placeholder-wrapper {
  margin: 70px 0;
}

@media (min-width: 920px) {
  #klantoverzicht::v-deep .content-wrapper > .content-wrapper {
    flex-direction: row;
  }

  .graph-wrapper {
    min-width: 500px !important;
    width: unset;
    max-width: 500px;
  }
}

@media (min-width: 1300px) {
  .graph-wrapper {
    min-width: 700px !important;
    width: unset;
    max-width: 700px;
  }
}

h4 {
  font-weight: 500 !important;
  margin: 0px;
  margin-bottom: 4px;
}

.graph-details {
  font-weight: 300 !important;
  font-size: 18px;
}

b {
  font-weight: 600 !important;
}

.section {
  margin: 14px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

p {
  margin: 0px;
}

.tag {
  font-size: 10px !important;
  border-radius: 2px;
  padding: 1px 5px;
  color: white;
  font-weight: 600;
}

.tag + .tag {
  margin-left: 4px;
}

.dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 1000px;
}

.name-wrapper {
  color: currentColor;
}

.name-wrapper:hover {
  text-decoration: underline;
}

.date-picker-btn {
  background-color: green !important;
}

.grid-filters {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr 1fr;
}

.chart {
  border-left: 1px solid #efeff0;
}

.chart,
.chart > div {
  height: 100%;
}

@media (max-width: 1000px) {
  .grid-filters {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .chart {
    margin: 0 !important;
    margin-top: 3px !important;
  }
}

@media (max-width: 800px) {
  .grid-filters {
    grid-template-columns: 1fr;
  }
}
</style>

<style>
.advice-order-filters .date-picker-button {
  padding: 9.5px !important;
}

.advice-order-filters .date-picker-button {
  padding: 9.5px !important;
}

.text-order-success {
  color: #16d379;
}

.text-order-failed {
  color: #c7314a;
}

.text-order-normal {
  color: #6d6e71;
  font-size: 14px;
}

.order-font-size-normal {
  font-size: 14px;
  padding: 5px 0;
}

.order-font-size-sm {
  font-size: 13px;
}

.product-show-all-btn {
  background-color: white !important;
  border-radius: 2px;
}

.btn-secondary-two {
  background-color: #a7a9ab;
  padding: 10px !important;
}

.btn-default-outline {
  background: #fff;
  border: 0.5px solid #d1d3d4;
  padding: 10px 13px;
}

.text-success-order {
  color: #16d379;
}

.text-danger-order {
  color: #c7314a;
}

.modal-custom {
  position: fixed;
  margin: 5px !important;
  width: calc(100% - 10px);
}

.modal-custom .modal-content {
  height: calc(100vh - 20px);
}

@media (max-width: 640px) {
  .btn-group-responsive {
    flex-direction: column;
    width: 100%;
    min-width: 100px;
  }

  .btn-group-responsive button {
    width: 100%;
    text-align: left;
  }

  .filter-responsive {
    flex-direction: column;
  }

  .filter-responsive label {
    width: 30px;
    margin-bottom: 5px;
  }
}

.sticky.top-sticky {
  background-color: white;
  border: 1px solid #dee2e6;
  z-index: 10;
  margin: auto;
  padding: 0 10px;
}

.img-thumbnail {
  border: none;
  box-shadow: none;
}

.carousel-indicators li {
  border: 2px solid rgba(255, 255, 255, 0.5);
  height: 50px;
  margin-left: 2px;
  margin-right: 2px;
  opacity: 0.5;
  width: 50px;
}

.carousel-indicators li::after {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.75);
  content: '';
  display: block;
  height: 1px;
  width: 100%;
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-item {
  height: 200px;
}

.carousel-item img {
  height: 100% !important;
  width: 100%;
  object-fit: cover;
}

.carousel-control-prev-icon {
background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%33c9d2' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e") !important;
}

.carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%33c9d2' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e") !important;
}
</style>
